import type { UiTextTypeEnum } from "@ory/kratos-client";
import type React from "react";
import { translateNodeLabel } from "~/components/KratosFlow/translate";
import type { NodeInputProps } from "./helpers";

export const NodeInputSubmit: React.FC<NodeInputProps> = ({
	node,
	attributes,
	disabled,
}) => {
	const labelType: UiTextTypeEnum = node.meta.label?.type ?? "info";

	const btnClassName = (t: UiTextTypeEnum): string => {
		switch (t) {
			case "info":
				return "btn-t4-primary btn-lg";
			case "error":
				return "btn-t4-danger";
			case "success":
				return "btn-t4-border";
			default:
				return "btn-t4-primary";
		}
	};

	return (
		<div className="w-full inline-block text-center mt-8">
			<button
				type="submit"
				className={`btn ${btnClassName(labelType)} rounded-full`}
				name={attributes.name}
				value={attributes.value || ""}
				disabled={attributes.disabled || disabled}
			>
				{translateNodeLabel(node)}
			</button>
		</div>
	);
};
